import ChatHeader from '../components/chat/header';
import React, { ReactNode } from 'react';
import { Sheet, Box } from '@mui/joy';

interface IBot {
	showBackButton: boolean;
	showMenuButton: boolean;
	title: string;
	children?: ReactNode;
	footer?: ReactNode;
	previousPathname?: string;
}
const Bot = ({
	children,
	showBackButton,
	showMenuButton,
	title,
	footer,
	previousPathname,
}: IBot) => {
	return (
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'center',
				bgcolor: 'background.body',
				height: '100dvh',
			}}
		>
			<Sheet
				variant='plain'
				sx={{
					display: 'flex',
					flexDirection: 'column',
					height: '100%',
					width: '100%', // Full width on small screens
					maxWidth: '60%', // Constrained to 70% on larger screens
					bgcolor: 'transparent',
					'@media (max-width: 900px)': {
						maxWidth: '100%', // Full width on small screens (adjust as needed)
					},
				}}
			>
				<Box
					sx={{ position: 'sticky', top: 0, zIndex: 10, bgcolor: 'transparent' }}
				>
					<ChatHeader
						title={title}
						showMenuButton={showMenuButton}
						showBackButton={showBackButton}
						previousPathname={previousPathname}
					/>
				</Box>
				{children}
				{footer || null}
			</Sheet>
		</Box>
	);
};

export default Bot;
